/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { useEffect, useRef, memo } from '@wordpress/element';
import { SearchControl } from '@wordpress/components';
import { useDebouncedInput } from '@wordpress/compose';

/**
 * Internal dependencies
 */
import { jsx as _jsx } from "react/jsx-runtime";
const Search = memo(function Search({
  label,
  view,
  onChangeView
}) {
  const [search, setSearch, debouncedSearch] = useDebouncedInput(view.search);
  useEffect(() => {
    var _view$search;
    setSearch((_view$search = view.search) !== null && _view$search !== void 0 ? _view$search : '');
  }, [view.search, setSearch]);
  const onChangeViewRef = useRef(onChangeView);
  const viewRef = useRef(view);
  useEffect(() => {
    onChangeViewRef.current = onChangeView;
    viewRef.current = view;
  }, [onChangeView, view]);
  useEffect(() => {
    onChangeViewRef.current({
      ...viewRef.current,
      page: 1,
      search: debouncedSearch
    });
  }, [debouncedSearch]);
  const searchLabel = label || __('Search');
  return /*#__PURE__*/_jsx(SearchControl, {
    __nextHasNoMarginBottom: true,
    onChange: setSearch,
    value: search,
    label: searchLabel,
    placeholder: searchLabel,
    size: "compact"
  });
});
export default Search;
//# sourceMappingURL=search.js.map